@if (loading()) {
  <app-loading-card title="Loading your Projects...">
  </app-loading-card>
}
@if (projects(); as projects) {
  <app-header title="Your Projects"
              description="Create and manage your projects"
              [enableAddBtn]="true"
              (addBtnClick)="createProject()"
              addBtnLabel="Create Project">
  </app-header>
  @if (projects.length > 0) {
    <table mat-table [dataSource]="projects">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name</th>
        <td mat-cell *matCellDef="let project">
          <a [routerLink]="['/project', project.id]">
            {{ project.name }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="topic">
        <th mat-header-cell *matHeaderCellDef> Description</th>
        <td mat-cell *matCellDef="let project"> {{ project.topic }}</td>
      </ng-container>


      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let project">
          <button mat-icon-button [matMenuTriggerFor]="projectTableMenu"
                  [matMenuTriggerData]="{project: project}"
                  aria-label="Context Menu for each project">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  } @else {
    <app-empty-state
      title="Start your first project"
      subtitle="You haven't created any projects yet. Start by creating a new project to get started"
      icon="not_started"
      primaryButtonLabel="Create a new project"
      [primaryButtonEnabled]="true"
      (cta)="createProject()"
    >
    </app-empty-state>
  }
}
<mat-menu #projectTableMenu="matMenu">
  <ng-template matMenuContent let-project="project">
    <button mat-menu-item (click)="deleteProject(project)">
      <mat-icon>delete</mat-icon>
      <span>Delete</span>
    </button>
  </ng-template>
</mat-menu>
